import React from "react";
import { Link } from "react-router-dom";

const AdminHeader = () => {
  return (
    <header id="page-topbar">
      <div className="g_between">
        <h6>Hello User</h6>
        <Link to={"/logout"}>Logout</Link>
      </div>
    </header>
  );
};

export default AdminHeader;
